import { DISEASE } from './disease';

export const CHAT_DISEASES = [
  DISEASE.AML,
  DISEASE.BLADDER_2,
  DISEASE.BRAIN,
  DISEASE.BREAST_2,
  DISEASE.CLL,
  DISEASE.CRC_2,
  DISEASE.GI_TRACT,
  DISEASE.HCC,
  DISEASE.HNSCC,
  DISEASE.LUNG,
  DISEASE.MDS,
  DISEASE.MELANOMA_2,
  DISEASE.MESO,
  DISEASE.MM,
  DISEASE.MPN,
  DISEASE.NHL,
  DISEASE.OVARIAN,
  DISEASE.PROSTATE,
  DISEASE.PROSTATE,
  DISEASE.RCC,
  DISEASE.UTERINE,
  DISEASE.SARCOMA,
  DISEASE.CERVICAL,
];
